import { format, isToday, isYesterday } from "date-fns";

export const formatNumber = (value?: number | string | null) =>
  Number(value || 0).toLocaleString();

const compactFormatter = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export const formatCompact = (value?: number | string | null) =>
  compactFormatter.format(Number(value || 0));

export const formatMoney = (value?: number | string | null, currency = "TZS") =>
  `${currency} ${formatNumber(value)}`;

export const humanize = (value?: string | null) =>
  (value || "")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const formatActivityDate = (iso: string) => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  if (isToday(date)) return `Today, ${format(date, "HH:mm")}`;
  if (isYesterday(date)) return "Yesterday";
  return format(date, "MMM d");
};

export const formatMonthLabel = (month: string) => {
  const isoMatch = /^(\d{4})-(\d{2})/.exec(month);
  if (isoMatch) {
    return format(new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, 1), "MMM");
  }
  return month.split(/\s+/)[0].slice(0, 3);
};

export const getGreeting = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};
